















import { Component, Emit, Prop, Watch, Vue } from "vue-property-decorator";
import { Creative } from "@/interfaces/creatives";

@Component<CreativeBox>({
  data() {
    return {};
  }
})
export default class CreativeBox extends Vue {
  @Prop({ required: true })
  creative!: Creative;

  get isImage() {
    return this.creative.type === "image" || this.creative.type === "banner" || this.creative.type === "gif" || this.creative.type === "print";
  }
  get isAudio() {
    return this.creative.type === "audio";
  }
  get isVideo() {
    return this.creative.type === "video";
  }
}
